var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiHeartFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_19141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4135 2.75C34.7925 2.75 29.9388 6.04175 27.4995 10.8432C25.0603 6.04175 20.2065 2.75 14.5855 2.75C6.52801 2.75 -0.000488281 9.50675 -0.000488281 17.8227C-0.000488281 26.1387 4.99626 33.7617 11.4533 40.0235C17.9103 46.2852 27.4995 52.25 27.4995 52.25C27.4995 52.25 36.778 46.3842 43.5458 40.0235C50.7645 33.242 54.9995 26.1635 54.9995 17.8227C54.9995 9.482 48.471 2.75 40.4135 2.75Z",
    fill: "#006E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_19141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiHeartFill);
export default __webpack_public_path__ + "static/media/si_heart-fill.f800f99d71c5ec6011cd22031b600da9.svg";
export { ForwardRef as ReactComponent };